export function RenderTabs({
  isMobileOtpEnabled = false,
  isEmailOtpEnabled = false,
  isFirstTab = false,
  isSecondTab = false,
  FirstTabLabalName = "firstLabal",
  SecondTabLabalName = "SecondLabal",
  tabValue,
  onChange,
  t
}) {
  const tabs = [];

  // First Tab
  if (isMobileOtpEnabled || isFirstTab) {
    tabs.push({
      label: isMobileOtpEnabled
        ? t("phoneNumberLabel")
        : t(FirstTabLabalName)
    });
  }

  // Second Tab
  if (isEmailOtpEnabled || isSecondTab) {
    tabs.push({
      label: isEmailOtpEnabled
        ? t("emailAddressLabel")
        : t(SecondTabLabalName)
    });
  }

  return (
    <div className="tab-bar">
      {tabs.map((tab, index) => (
        <button
          key={index}
          className={`tab-bar-label ${tabValue === index ? "active" : ""}`}
          onClick={() => onChange(index)}
        >
          {tab.label}
        </button>
      ))}

      {/* Indicator */}
      <div
        className="indicator"
        style={{
          width: `${100 / tabs.length}%`,
          transform: `translateX(${tabValue * 100}%)`
        }}
      />
    </div>
  );
}
